<template>
	<div class="footer_wrap">
		<div class="footer_top">
			<div class="ftop_view">
				<div class="ftop_vleft">
					<div class="ftop_vtitle">Pla Pla</div>
					<div class="ftop_vcont">
						<div class="ftop_vtext" :class="isPrivacy ? 'ftop_vtext_active' : ''" @click="gotoPrivacy">
							Aviso de Privacidad
						</div>
						<div class="ftop_vtext" :class="isProvision ? 'ftop_vtext_active' : ''" @click="gotoProvision">
							Términos y Condiciones
						</div>
					</div>
				</div>
				<div class="ftop_vmiddle">
					<!--<div class="ftop_vtitle">Sitios de referencia</div>
					<div class="ftop_vcont">
						<div class="ftop_vicon">
							<img src="@/assets/imgs/footer_icon.png" alt="" />
						</div>
					</div>-->
				</div>
				<div class="ftop_vright">
					<div class="ftop_vtitle">Contáctanos</div>
					<div class="ftop_vcont">
						<div class="ftop_vtext">Atención al clientes：(55) 8526-6878</div>
						<div class="ftop_vtext">Atención al clientes：5646391950</div>
						<div class="ftop_vtext">Correo electrónico：plaplaprestamos@gmail.com</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer_down">
			<div class="fdow_view">
				<div class="fdow_vleft">
					<img src="@/assets/imgs/pla_logo.png" alt="" />
				</div>
				<div class="fdow_vright">
					<div class="fdow_vricon">
						<a
								href="https://play.google.com/store/apps/details?id=cash.prestamos.credit.instalacion.kueski.plapla"
								target="_blank"
								class="playBtn"
						>
            <img src="@/assets/imgs/footer_google.png" alt="">
						</a>
          </div>
          <div class="fdow_vricon">
            <!--<img src="@/assets/imgs/footer_ios.png" alt="">-->
          </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import './scss/foot.scss'

	export default {
		name: 'footPage',
		data() {
			return {
				isPrivacy: false,
				isProvision: false,
			}
		},
		mounted() {
			let usePath = this.$route.path

			if (usePath.indexOf('privacy') != -1) {
				this.isPrivacy = true
			} else {
				this.isPrivacy = false
			}

			if (usePath.indexOf('provision') != -1) {
				this.isProvision = true
			} else {
				this.isProvision = false
			}
		},
		methods: {
			gotoPrivacy() {
				this.$router.push({
					path: '/privacy',
				})
			},
			gotoProvision() {
				this.$router.push({
					path: '/provision',
				})
			},
		},
	}
</script>
